<df-header-tabs
  class="tabs"
  [tabs]="tabs"
></df-header-tabs>
